import { observable } from "mobx";
import { Type } from "class-transformer";
import MonthOfYearRangeRequest from "./monthOfYearOpenRangeRequest";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CreateAccountingDocumentsInventoryRequest {
  @observable
  @Type(() => MonthOfYearRangeRequest)
  accountingPeriodMonthRange!: MonthOfYearRangeRequest;
}
